module.exports = __webpack_public_path__ + "img/breadcalc-logo.4e0b8fa1.png";